import groq from 'groq'

import { imageFragment } from './image'

const institutionPrintTypesFragment = groq`
  logo,
  back,
  freetext,
`

const institutionPermissionFragment = groq`
  apparel,
  yearbook,
  festival,
  teamapparel,
  merch,
  photobook,
`

export const institutionPrintFragment = groq`
  title,
  type,
  printSku,
  printColor,
  "printImage": print {
    ${imageFragment}
  },
`

export const institutionFragment = groq`
  "slug": slug.current,
  name,
  id,
  address,
  city,
  postalCode,
  description,
  domain,
  email,
  phone,
  grades,
  numberOfStudents,
  prints[] {
    ${institutionPrintFragment}
  },
  permission {
    ${institutionPermissionFragment}
  },
  unavailablePrintTypes {
    ${institutionPrintTypesFragment}
  },
`

export const institutionItemFragment = groq`
  "id": _id,
  isPublic,
  name,
  unavailablePrintTypes {
    ${institutionPrintTypesFragment}
  },
`

export const getInstitutionByIdQuery = groq`
  *[
    _type == "school" &&
    _id == $id
  ][0] {
    ${institutionFragment}
  }
`
